import TableComponent from "components/Table"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import { getAdReports } from "store/actions"
import adReportListColumns from "./adReportListColumns"

const AdReports = ({ adReports, getAdReports, handleRemoveWidget }) => {
  useEffect(() => {
    getAdReports({ o: "total_clicks", od: "desc", page: 1, per_page: 5 })
  }, [])
  return (
    <Col xs={12}>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <h5>Ad Reports</h5>
            </Col>
            <Col xs="auto">
              <i
                className="bx bx-x font-size-22"
                style={{ cursor: "pointer" }}
                onClick={handleRemoveWidget}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <TableComponent
                data={
                  adReports?.data?.map((item, index) => ({
                    ...item,
                    id: index,
                  })) || []
                }
                columns={adReportListColumns()}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

const mapStateToProps = state => ({
  adReports: state.Analytics.adReports,
})

const mapDispatchToProps = dispatch => ({
  getAdReports: values => dispatch(getAdReports(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AdReports)
